module.exports = __webpack_public_path__ + "img/main.59f1b87a.jpg";